/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Settings_Showlistingscale2Inputs */

const he_extension_popup_settings_showlistingscale2 = /** @type {(inputs: Extension_Popup_Settings_Showlistingscale2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הצג סרגל מחיר ברשימות`)
};

const en_extension_popup_settings_showlistingscale2 = /** @type {(inputs: Extension_Popup_Settings_Showlistingscale2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show price-scale on listings`)
};

/**
* | output |
* | --- |
* | "Show price-scale on listings" |
*
* @param {Extension_Popup_Settings_Showlistingscale2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_settings_showlistingscale2 = /** @type {((inputs?: Extension_Popup_Settings_Showlistingscale2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Settings_Showlistingscale2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_settings_showlistingscale2(inputs)
	return en_extension_popup_settings_showlistingscale2(inputs)
});
export { extension_popup_settings_showlistingscale2 as "extension_popup_settings_showListingScale" }